/** Section the shot was opened from, matching the toolbar crumb. */
export const SHOT_RETURN_PLACES = [
  "storyboard",
  "generations",
  "animatics",
  "library",
  "assembly",
  "overview",
  "canvas",
  "studio",
  "seasons",
  "script",
  "characters",
  "locations",
  "props",
  "cameras",
  "presets",
  "skills",
] as const

export type ShotReturnPlace = (typeof SHOT_RETURN_PLACES)[number]

/** First path segment under `/workspace/`, when it is a known section crumb. */
const WORKSPACE_SECTION_TO_PLACE: Record<string, ShotReturnPlace> = {
  storyboard: "storyboard",
  generations: "generations",
  animatics: "animatics",
  library: "library",
  assembly: "assembly",
  overview: "overview",
  canvas: "canvas",
  studio: "studio",
  seasons: "seasons",
  script: "script",
  characters: "characters",
  locations: "locations",
  props: "props",
  camera_presets: "cameras",
  presets: "presets",
  skills: "skills",
}

/**
 * Place name for «Назад к …», from the current page URL.
 * Unknown sections return null so the button falls back to «Назад».
 */
export function shotReturnPlaceKey(href: string): ShotReturnPlace | null {
  const path = href.split(/[?#]/)[0] ?? href
  if (/\/monitoring\/generations(?:\/|$)/.test(path)) return "generations"
  if (/\/canvas(?:\/|$)/.test(path)) return "canvas"
  const section = path.match(/\/workspace\/([^/]+)/)?.[1]
  if (!section) return null
  return WORKSPACE_SECTION_TO_PLACE[section] ?? null
}
